import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PropertyTypeService } from '../property-type.service';
import { PropertyTypeEditComponent } from '../property-type-edit/property-type-edit.component';
import { PropertyType, AddPropertyType } from '../property-type.model';
@Component({
  selector: 'app-property-types',
  templateUrl: './property-types.component.html',
  styleUrls: ['./property-types.component.css']
})
export class PropertyTypesComponent implements OnInit {

    @Input() public propertyType: PropertyType;
    public propertyName;
    constructor(private propertyTypeService: PropertyTypeService, public dialog: MatDialog) { }

    ngOnInit() {
        this.propertyName = this.propertyType.propertyField == 'Fields.1553' ? this.propertyType.name + '- ULDD' : this.propertyType.name;
    }

    editPropertType(propertyType) {
        let dialogRef = this.dialog.open(PropertyTypeEditComponent, {
            data: this.propertyType,
            height: "330px",
            width: "520px",
            panelClass:"property-type-screen"
        });
        dialogRef.afterClosed().subscribe((result: PropertyType) => {
            if (result) { this.propertyName = result.propertyField == 'Fields.1553' ? this.propertyType.name + '- ULDD' : this.propertyType.name; }
        })
    }

    deletePropertyType(propertyType: PropertyType) {
        if (confirm('Are you sure you want to delete ' + propertyType.name + '?')) {
            this.propertyTypeService.deletePropertyTypes(propertyType.id)
                .then(success => {
                    if (!success)
                        confirm('There was an error processing your request.');
                })
                .catch(error => {
                    confirm('There was an error processing your request.');
                });
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-types/property-types.component.ts